// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:480px){.messengers[data-v-b9fe2736]{display:flex;justify-content:space-between}.messengers>*[data-v-b9fe2736]{width:49%}}", ""]);
// Exports
module.exports = exports;
